import React, { Component } from 'react';

class InvalidAccess extends Component {
    render() {
        return (
            <div>You do not have the appropriate access to view this page</div>
        )
    }
}

export default InvalidAccess


// WEBPACK FOOTER //
// ./src/components/Auth/InvalidAccess.js